export default "__VITE_ASSET__CdaO7pht__"